// @flow

"use strict";

/**
 * Cookie関連ユーティリティクラス
 */
export default class CookieUtil {

  /**
   * UUIDKEY
   * @returns {string}
   * @constructor
   */
  static KEY_UUID(): string {
    return '__uuiduz';
  }

  /**
   * Cookieに指定したKeyで保存
   * @param document
   * @param key
   * @param value
   * @param expires
   * @param path
   */
  static setCookie(document: HTMLDocument, key: string, value: string, expires: Date, path: string){
    if (typeof expires === 'undefined') {
      expires = new Date();
      expires.setMilliseconds(expires.getMilliseconds() + (180 * 864e+5)); // デフォルトの有効期限は180日。ミリ秒で設定。
    }
    path = typeof path === 'undefined' ? '/' : path;

    document.cookie = [
      key, '=', encodeURIComponent(value),
      '; expires=' + expires.toUTCString(), // max-ageはIEの一部のバージョンでサポートされていないため、expiresを使用する
      '; path=' + path
    ].join('');
  }

  /**
   * 指定したKeyのCookieを取得
   * @param document
   * @param key
   * @returns {string}
   */
  static getCookie(document: HTMLDocument, key: string): string {
    let result;
    const cookies = document.cookie ? document.cookie.split('; ') : [];
    for (let i = 0; i < cookies.length; i++) {
      let parts = cookies[i].split('=');
      let value = decodeURIComponent(parts[1]);
      if (parts[0] == key) {
        result = value;
        break;
      }
    }
    return result;
  }

  /**
   * UUIDをCookieに保存
   * @return {void}
   */
  static saveUUID(uuid: string, document: HTMLDocument) {
    CookieUtil.setCookie(document, CookieUtil.KEY_UUID(), uuid);
  }

  /**
   * CookieからUUIDを取得
   * @return {string}
   */
  static loadUUID(document: HTMLDocument): string {
    const uuid = CookieUtil.getCookie(document, CookieUtil.KEY_UUID());
    return uuid ? uuid : "";
  }
}


// WEBPACK FOOTER //
// ./src/js/util/cookie-util.js